export const MENU_TITLES = {
	DASHBOARD: "Dashboard",
	MY_FLEET: "My Fleet",
	ANNUAL_EMISSION_VERIFICATION: "Annual Emission Verification",
	PLAN_VERIFICATION: "Plan Verification",
	REPORTS: "Reports",
	EUMRV_COMPANY_EMISSION_VERIFICATION_REPORT: "EU MRV Company Emissions Reports",
	PORT_CODES: "Port Codes",
	CII_CALCULATIONS: "CII Calculator",
	ACCOUNT: "Account",
	MANAGE_MY_ACCOUNT: "Manage My Account",
	NOTIFICATION_SETTINGS: "Notification Settings",
	SUPPORT: "Support",
	HELP: "Help",
	SIGN_OUT: "Sign out",
	ADMIN: "Admin",
	MANAGE_USER: "Manage User",
	MANAGE_WCN: "Manage WCN",
	EVENT_LOGS: "Event Logs",
	BULK_EXPORT: "Bulk Export",
	UNSATISFACTOTY_CII_RATINGS_VESSEL_EXPORT: "Unsatisfactory CII Ratings Vessel Export",
	FEU_COMPLIANCE_BALANCE_REPORTS: "FEU Compliance Balance Reports",
};